import type { DungeonFloor, DungeonRoom, PlayerState } from '../game/types';

export function getRoom(floor: DungeonFloor, roomId: string): DungeonRoom | undefined {
  return floor.rooms[roomId];
}

export function getCurrentRoom(floor: DungeonFloor): DungeonRoom | undefined {
  return getRoom(floor, floor.playerRoomId);
}

/** Required-interaction rooms block leaving until cleared. */
export function canLeaveRoom(room: DungeonRoom | undefined): boolean {
  return Boolean(room && (!room.isRequiredInteraction || room.isCleared));
}

function clampMana(player: PlayerState, mana: number): PlayerState {
  return { ...player, mana: Math.max(0, Math.min(player.maxMana, mana)) };
}

/** Safe room: restore 100% mana, no ambush. */
export function restSafe(player: PlayerState): PlayerState {
  return clampMana(player, player.maxMana);
}

/** Unsafe rest: restore 25% max mana; caller starts the ambush. */
export function restUnsafe(player: PlayerState): PlayerState {
  return clampMana(player, player.mana + Math.floor(player.maxMana * 0.25));
}
